import React, { useContext } from 'react'
import { Box, Text, Heading, ButtonPrimary } from '@primer/components'
import { Link } from "react-router-dom"
import LazyLoad from 'react-lazyload'

import exampleMessages from '../../fixtures/issues-django-and-python.json'
import { useCategory, CorpusContext } from '../../hooks/useCorpus'
import { useProduct } from '../../hooks/useProduct'
import useAnalytics from '../../hooks/useAnalytics'
import { groupMessagesByFile as groupMessages } from '../../helpers'
import HeaderLevelTwoRepository from '../../components/HeaderLevelTwoRepository'
import Card from '../../components/BeforeAfter/CardWithContext'
import * as constants from '../../constants'
import PullRequestTimeline from '../Repository/PullRequestTimeline'
import { getMessageCentricMessages } from '../Repository'


export default function(props) {
  const { corpus } = useContext(CorpusContext)
  const messages = getMessageCentricMessages(exampleMessages)
  const report = groupMessages(exampleMessages, true, corpus)
  const productDetails = useProduct()

  const analytics = useAnalytics() 

  return (
    <Box className="position-relative pt-md-8 pt-4 pl-md-4 pr-md-4 pl-sm-2 pr-sm-4">
      <Box className="container-xl  mb-4 mb-md-0 text-center">
        <Heading>A quick demo</Heading>
        <Text as="p" className="lead">This is a sample of the kind of advice you can expect from {productDetails.name} during code review.</Text>
      </Box>
      <HeaderLevelTwoRepository
        owner={'code-review-doctor'}
        repository={'a-quick-example'}
        adviceCount={messages.length}
      />
      <Box alignItems="center" className="container-xl mt-3 d-md-flex mb-4 mb-md-0">
        <PullRequestTimeline
          messages={messages}
          report={report}
          repoBlobLink={`https://github.com/code-review-doctor/a-quick-example/blob/django-and-python`}
          minimalistAdvice={false}
          showFilter={false}
          scmKey={constants.SCM_BITBUCKET}
        />
      </Box>
      <Box className="container-xl mt-4 pb-10 text-center">
        <ButtonPrimary
          as={Link}
          variant="large"
          className="f3 pt-3 pb-3 pl-2 pr-2"
          to={'/features/bitbucket/price'}
          onClick={() => analytics.track('FUXBAWEE')}
        >
          Setup Bitbucket integration
        </ButtonPrimary>
      </Box>
    </Box>
  )
}
